import { CoreMenuCategoryPage } from 'src/dispensary/core-menu/category';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { getDispensaryServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getDispensaryServerSideProps;

CoreMenuCategoryPage.layout = CoreMenuLayout;
export default CoreMenuCategoryPage;
